<app-dialog-header
  [titleId]="titleId"
  [title]="(sent ? 'ForgotPassword.SentTitle' : 'ForgotPassword.Title') | translate"
  [closeLabel]="'General.Close' | translate"
  (closed)="dialogRef.close()"
></app-dialog-header>

<ng-container *ngIf="sent; else requestForm">
  <mat-dialog-content>
    <div class="flex items-start gap-4" role="status">
      <div class="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-theme-50 text-theme-700">
        <mat-icon aria-hidden="true">mail</mat-icon>
      </div>
      <p class="m-0 text-base leading-normal">{{ 'ForgotPassword.Sent' | translate }}</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="button" mat-dialog-close>
      {{ 'ForgotPassword.Back' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #requestForm>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-dialog-content>
      <div class="flex flex-col gap-4">
        <app-tap-alert
          *ngIf="data?.resetRequired"
          type="warning"
          message="Login.ResetRequired"
        ></app-tap-alert>
        <p class="m-0 text-sm leading-normal text-gray-600">{{ 'ForgotPassword.Intro' | translate }}</p>
        <mat-form-field appearance="outline" class="tl-autofill-field">
          <mat-label>{{ 'ForgotPassword.Identifier' | translate }}</mat-label>
          <input
            matInput
            id="forgotPwdIdentifier"
            formControlName="identifier"
            autocomplete="username"
            cdkFocusInitial
          />
          <mat-error>{{ 'ForgotPassword.IdentifierRequired' | translate }}</mat-error>
        </mat-form-field>
        <p *ngIf="sendError" class="m-0 text-sm text-status-red" role="alert">
          {{ sendError | translate }}
        </p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button color="primary" type="button" mat-dialog-close>
        {{ 'Dialog.Cancel' | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit" [disabled]="sending">
        {{ 'ForgotPassword.SendLink' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
